import { render, staticRenderFns } from "./businessDistrictDetail.vue?vue&type=template&id=7f01eac0&scoped=true&"
import script from "./businessDistrictDetail.vue?vue&type=script&lang=js&"
export * from "./businessDistrictDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessDistrictDetail.vue?vue&type=style&index=0&id=7f01eac0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01eac0",
  null
  
)

export default component.exports